import styled from "styled-components";

export const CommercialWrap = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 760px) {
    gap: 10px;
  }
`;

export const ModeBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 2px 2px 10px;
  border-bottom: 1px solid #dfe5ec;

  @media (max-width: 760px) {
    align-items: flex-start;
    flex-direction: column;

    .ant-segmented {
      width: 100%;
    }

    .ant-segmented-group,
    .ant-segmented-item {
      flex: 1;
    }
  }
`;

export const FilterBar = styled.div`
  position: sticky;
  top: 52px;
  z-index: 10;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 10px;
  background: #fff;
  border: 1px solid #dfe5ec;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgb(15 23 42 / 4%);

  @media (max-width: 760px) {
    position: static;
    padding: 8px;

    > .ant-select,
    > .ant-input,
    > .ant-input-affix-wrapper {
      width: calc(50% - 4px) !important;
      min-width: 0;
      flex: 1 1 calc(50% - 4px);
    }

    > .ant-btn {
      min-width: 0;
      flex: 1 1 calc(25% - 6px);
      padding-inline: 8px;
    }
  }
`;

export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;

  @media (max-width: 1500px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 760px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
`;

export const KpiBox = styled.div`
  position: relative;
  min-width: 0;
  min-height: 92px;
  padding: 12px 13px 10px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dfe5ec;
  border-top: 3px solid #2563eb;
  border-radius: 8px;

  &:nth-child(2) { border-top-color: #0891b2; }
  &:nth-child(3) { border-top-color: #16a34a; }
  &:nth-child(4) { border-top-color: #7c3aed; }
  &:nth-child(5) { border-top-color: #dc2626; }
  &:nth-child(6) { border-top-color: #d97706; }

  @media (max-width: 760px) {
    min-height: 84px;
    padding: 9px 10px 8px;
  }
`;

export const KpiLabel = styled.div`
  margin-bottom: 4px;
  color: #64748b;
  font-size: 12px;
`;

export const KpiValue = styled.div`
  color: #111827;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;

  @media (max-width: 760px) {
    font-size: 21px;
  }
`;

export const KpiHint = styled.div`
  min-height: 18px;
  margin-top: 3px;
  color: #94a3b8;
  font-size: 12px;
`;

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(440px, 1.35fr) minmax(360px, 0.9fr);
  gap: 12px;

  @media (max-width: 1280px) {
    grid-template-columns: 1fr;
  }
`;

export const Section = styled.section`
  min-width: 0;
  padding: 13px 14px;
  background: #fff;
  border: 1px solid #dfe5ec;
  border-radius: 8px;

  .ant-table-wrapper {
    min-width: 0;
  }

  @media (max-width: 760px) {
    padding: 10px;

    .ant-tabs-nav {
      margin-bottom: 10px;
    }

    .ant-tabs-nav-wrap {
      overflow-x: auto;
      scrollbar-width: none;
    }

    .ant-tabs-nav-wrap::-webkit-scrollbar {
      display: none;
    }

    .ant-tabs-nav-list {
      flex: none;
    }

    .ant-table-container,
    .ant-table-content,
    .ant-table-body {
      max-width: 100%;
      overflow-x: auto !important;
    }

    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      padding: 8px 6px;
    }

    .ant-pagination {
      justify-content: center;
      gap: 4px;
    }

    .ant-pagination-options {
      display: none;
    }
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
  color: #111827;
  font-size: 14px;
  font-weight: 650;

  @media (max-width: 760px) {
    align-items: flex-start;
    flex-wrap: wrap;
  }
`;

export const TrendHeader = styled.div`
  display: grid;
  grid-template-columns: 104px minmax(120px, 1fr) minmax(200px, 216px);
  align-items: center;
  gap: 8px;
  min-height: 36px;
  border-bottom: 1px solid #edf1f5;
  color: #475569;
  font-size: 12px;
  font-weight: 600;

  @media (max-width: 760px) {
    display: none;
  }
`;

export const TrendRow = styled.div`
  display: grid;
  grid-template-columns: 104px minmax(120px, 1fr) minmax(200px, 216px);
  align-items: center;
  gap: 8px;
  min-height: 36px;
  border-bottom: 1px solid #edf1f5;
  color: #475569;
  font-size: 12px;

  &:last-child {
    border-bottom: 0;
  }

  @media (max-width: 760px) {
    grid-template-columns: 84px minmax(0, 1fr);
    gap: 8px;
    padding: 9px 0;
  }
`;

export const TrendBucket = styled.span`
  white-space: nowrap;

  @media (max-width: 760px) {
    color: #334155;
    font-weight: 600;
  }
`;

export const TrendMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;

  @media (max-width: 760px) {
    grid-column: 1 / -1;
    gap: 6px;
  }
`;

export const TrendMetric = styled.span`
  min-width: 0;

  @media (max-width: 760px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    padding: 5px 7px;
    background: #f8fafc;
    border-radius: 4px;
  }
`;

export const TrendMetricLabel = styled.span`
  display: none;

  @media (max-width: 760px) {
    display: inline;
    color: #94a3b8;
    font-size: 11px;
  }
`;

export const TrendBar = styled.div`
  display: flex;
  height: 8px;
  overflow: hidden;
  background: #e2e8f0;
  border-radius: 999px;
`;

export const TrendBarFill = styled.div<{ $percent: number }>`
  width: ${(props) => Math.max(0, Math.min(100, props.$percent))}%;
  height: 100%;
  background: #0f766e;
`;

export const TrendBarSegment = styled.div<{ $percent: number; $color: string }>`
  width: ${(props) => Math.max(0, Math.min(100, props.$percent))}%;
  height: 100%;
  background: ${(props) => props.$color};
`;

export const TrendLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 16px;
  margin: -4px 0 8px;
  color: #64748b;
  font-size: 12px;

  @media (max-width: 760px) {
    justify-content: flex-start;
    gap: 12px;
    margin-top: 0;
  }
`;

export const TrendLegendItem = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;

  &::before {
    width: 8px;
    height: 8px;
    background: ${(props) => props.$color};
    border-radius: 2px;
    content: "";
  }
`;

export const RateCell = styled.div`
  display: grid;
  grid-template-columns: minmax(42px, 1fr) 42px;
  gap: 6px;
  align-items: center;
  color: #475569;
  font-size: 12px;

  @media (max-width: 760px) {
    display: block;
    text-align: right;

    .ant-progress {
      display: none;
    }
  }
`;

export const JsonBlock = styled.pre`
  max-height: 360px;
  margin: 0;
  padding: 12px;
  overflow: auto;
  color: #dbeafe;
  background: #111827;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.6;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;
